import { ActionIcon, Button, Card, Code, createTheme, Input, NavLink, Paper, Select, TextInput } from '@mantine/core';

import './theme.css';

export const theme = createTheme({
  components: {
    ActionIcon: ActionIcon.extend({
      defaultProps: {
        className: 'transition-all',
      },
    }),
    Button: Button.extend({
      classNames: {
        root: 'btn transition-all',
      },
      styles: theme => ({
        root: {
          boxShadow: theme.shadows.md,
        },
      }),
    }),
    Card: Card.extend({
      defaultProps: {
        bg: 'var(--mantine-color-body)',
        p: 'lg',
        radius: 'md',
        shadow: 'none',
        withBorder: true,
      },
    }),
    Code: Code.extend({
      defaultProps: {
        bg: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-8))',
      },
      styles: (theme, props) => ({
        root: {
          padding: props.block ? theme.spacing.md : undefined,
        },
      }),
    }),
    Input: Input.extend({
      defaultProps: {
        radius: 'sm',
      },
    }),
    NavLink: NavLink.extend({
      defaultProps: {
        className: 'transition-all',
      },
    }),
    Paper: Paper.extend({
      defaultProps: {
        bg: 'var(--mantine-color-body)',
        p: 'md',
        radius: 'md',
        shadow: 'xl',
        withBorder: true,
      },
    }),
    Select: Select.extend({
      defaultProps: {
        comboboxProps: { transitionProps: { duration: 200, transition: 'pop' } },
      },
    }),
    TextInput: TextInput.extend({
      defaultProps: {
        radius: 'sm',
      },
    }),
  },
  other: {
    headerHeight: 124,
  },
  // Fixed px (not rem) so padding/gaps render identically standalone and when embedded in
  // a shell whose <html> font-size differs from the 16px Mantine assumes for rem tokens.
  spacing: {
    lg: '20px',
    md: '16px',
    sm: '12px',
    xl: '32px',
    xs: '10px',
  },
});
